var breakfast = [
    {
        "id": "1",
        "name": "Begal and Cream Cheese",
        "category": "breakfast",
        "img": "https://i.imgur.com/BaS2G0b.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 13.99
    },
    {
        "id": "2",
        "name": "Breakfast Sandwich",
        "category": "breakfast",
        "img": "https://i.imgur.com/zSbAh5u.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 10.99
    },
    {
        "id": "3",
        "name": "Baked Chicken fry",
        "category": "breakfast",
        "img": "https://i.imgur.com/lZCtGhb.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "4",
        "name": "Eggs Fried Benedict",
        "category": "breakfast",
        "img": "https://i.imgur.com/KUJHCRC.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 8.99
    },
    {
        "id": "5",
        "name": "Toast Croissant Fried Egg",
        "category": "breakfast",
        "img": "https://i.imgur.com/DPRhhsO.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 12.99
    },
    {
        "id": "6",
        "name": "Full Egg Toast Brunch",
        "category": "breakfast",
        "img": "https://i.imgur.com/Uo1nw53.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 9.99
    },


]
export default breakfast;